import { TooltipProps } from 'antd/es/tooltip';

import Tooltip from './tooltip';

export type { TooltipProps };
export default Tooltip;
